import * as React from 'react';
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { debounce } from "lodash";
import { fetchMiddlePanelPartiesData, resetMiddlePanelInitialState, resetMiddlePanel, deleteAssociatedParty} from '../../../../containers/WorkkardDetail/actions/action';
import ListingComponent from '../../../../components/ListingComponent';
import PartieCell from './partieCell';
import { StringConstants, MiddlePanelConstant } from "../../../../containers/WorkkardDetail/constants";
import LoaderComponent from '../../../../components/Loader';
import { showDialogueBox, hideDialogueBox  } from '../../../../components/DialogueBox/actions';
import {showRightPopUpeBox,hideRightPopUpBox} from "../../../../components/RightPopUpComponent/actions";
import AssociatedPartiesPanel from '../../../Header/AssociatedParties';
import { fetchPartyInfo } from '../../../Header/actions/action';
import WorkkardMultiOptionFilter from'../Filter/multiOptionFilter';
import Icons from "../../../../icons";
import { hideToast } from '../../../SpockViewPage/actions/action';
import ConfirmPrompt from "../../../../components/ConfirmationPrompt";
import EmptyScreen from '../../../../Emptyscreen';
import { isMobile, redirectURL, sortArrayByKey } from '../../../../common/util';
import { useLiveRefresh } from '../../../../utils/useLiveRefresh';

// Scoped to the open claim: party events arrive for every claim the user acts
// on, and this panel is only showing one of them. The domain array is hoisted
// so mapStateToProps does not allocate a new one on every store update.
const PARTY_DOMAINS = ['party'];

 class Parties extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            typeFilter: false,
            filterOptions: [],
            searchKeyword: "",
        }
        this.renderParties = this.renderParties.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.searchParties = debounce(this.searchParties, 500);
        this.onAddPartySuccess = this.onAddPartySuccess.bind(this);
        this.setInitialState = this.setInitialState.bind(this);
        this.onTypeFilterApply=this.onTypeFilterApply.bind(this);
    }

    // fetch parties when component mount first time
    componentDidMount() {
        window.addEventListener('newPartyAdded', this.onAddPartySuccess);
        const { parties } = this.props.middlePanel;

        if (this.props && this.props.workkard) {
            let urlHash = this.props.history.location.hash;
            if (window.performance) {
                if (performance.navigation.type == 1) {
                    urlHash='#parties';
                }
            }
            let partiesType = urlHash === "#parties" ? "All" : (urlHash.charAt(2) === 'p' ?
                urlHash.charAt(1) === 'a' ? MiddlePanelConstant.ActivityType : MiddlePanelConstant.WorkkardType:
                parties.type);

            this.onChangeType(partiesType)

            let filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type]

            const payload = {
                cId: this.props.workkard.Id,
                type: partiesType,
                actId: this.props.activityDetail.activityId || 0,
                skip: 0,
                take: 15,
                sortBy: 1,
                filterOption: filterOption,
                sort: "OPEN",
                rows: 15,
            }
            if ((partiesType === "All" || partiesType == MiddlePanelConstant.ActivityType && payload.actId > 0) || (partiesType == MiddlePanelConstant.WorkkardType)) {
                this.props.fetchMiddlePanelPartiesData(payload);
            }
        }
        this.setInitialState(parties);

    }

    // Fetch  parties data when switch  between activity or  when switch  between workkard and activity
    componentWillReceiveProps(newProps) {
        if (newProps && newProps.activityDetail && newProps.activityDetail.activityId !== this.props.activityDetail.activityId
            ||
            (newProps.middlePanel.parties.type !== this.props.middlePanel.parties.type)
        ) {
            const { parties } = newProps.middlePanel;
            const { workkard } = newProps;
            if(newProps.activityDetail.activityId !== this.props.activityDetail.activityId){
                const payload = {
                    type: 'parties',
                    value: parties.type,
                    filter: parties.filter
                }
                this.props.resetMiddlePanel(payload)
            }
            let filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type]
            const payload = {
                cId: workkard.Id,
                type: parties.type,
                actId: newProps.activityDetail.activityId,
                skip: 0,
                take: 15,
                sortBy: 1,
                filterOption: filterOption,
                sort: "OPEN",
                rows: 15,
                showToast:parties.showToast,
                key: this.state.searchKeyword
            }
            this.props.fetchMiddlePanelPartiesData(payload)
        }
        if(newProps.middlePanel.parties.type !== this.props.middlePanel.parties.type){
            this.setInitialState(newProps.middlePanel.parties)
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.refreshToken !== this.props.refreshToken) {
            this.refreshParties();
        }
    }

    // Refetches the first page with the filters currently on screen. The list is
    // accumulated by infinite scroll, so it has to be reset first or the fresh
    // page 0 would be appended to the stale pages already there.
    refreshParties() {
        const { parties } = this.props.middlePanel;
        const { workkard, activityDetail } = this.props;
        if (!workkard || !workkard.Id) return;

        const actId = (activityDetail && activityDetail.activityId) || 0;
        if (parties.type === MiddlePanelConstant.ActivityType && actId === 0) return;

        const filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type];
        this.props.resetMiddlePanel({ type: 'parties', value: parties.type });
        this.props.fetchMiddlePanelPartiesData({
            cId: workkard.Id,
            type: parties.type,
            actId,
            skip: 0,
            take: 15,
            sortBy: 1,
            filterOption,
            sort: "OPEN",
            rows: 15,
            key: this.state.searchKeyword,
        });
    }

    componentWillUnmount(){
        document.removeEventListener('newPartyAdded', this.onAddPartySuccess);
        this.props.hideToast();
    }

    setInitialState(parties){
        const {type} = parties;

        var filterOption = [];
        const keys = Object.keys(this.state.filterOptions);
        if(keys.length){
            this.state.filterOptions[keys[0]].options
                .filter((optionData) => optionData.checked === true )
                .forEach((filteredValue ) => {
                    filterOption = filterOption.concat(filteredValue.value);
                })
        }

        const filterOptions = {
            All: {
                name: '', value: '0', checked: type === "All" ? true : false,
                options: [
                    {name: 'Activity', value: 'activity', checked: ((type=='activity' || type === "All") ? true:false)},
                    {name: 'Workkard', value: 'workkard', checked: ((type=='workkard' || type === "All") ? true:false)},
                ]
            },
        }
        
        this.setState({
            filterOptions
        })

    }

    SeturlHash(hash){
        let redirectPath = {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: `${hash}`
        }
        redirectURL(this.props.history, redirectPath);
    }

    // function that handle if scroll on parties and fetch  next 10 parties data, update redux state and rerender parties tab
    onScrollHandler() {
        const { parties } = this.props.middlePanel;
        const { skip, take } = parties;
        let filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type]
        
        const payload = {
            cId: this.props.workkard.Id,
            type:  parties.type,
            actId: this.props.activityDetail.activityId,
            skip: (skip === 0 && take > 10 ) ? take : parseInt(skip)+parseInt(take),
            take : (skip === 0 && take > 15 ) ? 15 : parseInt(take),
            sortBy: 1,
            filterOption: filterOption,
            sort: "OPEN",
            rows: 15
        }
        if (skip + take < parties.total) {
            this.props.fetchMiddlePanelPartiesData(payload);
        }
    }

    // switch between activity and workkard
    onChangeType(selectedValue){
        let hash = selectedValue === MiddlePanelConstant.All ? "parties" : (selectedValue === MiddlePanelConstant.ActivityType ? 'ap' : 'cp')
        this.SeturlHash(hash);

        const payload = {
            type: 'parties',
            value: selectedValue,
        }
        this.props.resetMiddlePanel(payload)
    }

    onPartyInfoClick = ({eid,pid, type},showDelete=false) =>{
        const payload = {
            id: pid,
            flag: 'detail',     
            entity: '',
            entity_id: eid,
            entity_type: type,       //activity/workkard
        }
        this.props.fetchPartyInfo(payload);
        this.props.showRightPopUpeBox({
            flag: true,
            component: <AssociatedPartiesPanel showDelete={showDelete} handleDelete={()=>this.onDeleteClick({eid,pid, type})} showPartyInfo={true} openedFromMiddleTab={true} onClose={this.props.hideRightPopUpBox} associateWith={type == "wrk" ? "workkard":"activity"}/>,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        })
    }

    onPartyItemClick = (pid,party_type) => {
        if (objectCreationFactory) {
            let entity = party_type === "wrk" ? "workkard" : "activity";
            objectCreationFactory.GetControllerObject("Party").EditParty(pid, 'detail', true, entity);
        }
    }

    onDeleteClick = (partyData) => {
        // let modalCss=isMobile()?"modalContent small animated faster confirmModal fadeInUpx2":"modalContent small animated faster fadeInUpx2"
        this.props.showDialogueBox({
          flag: true,
          overlayClassName:"modal",
          contentClassName:"modalContent animated faster fadeInUpx2 small confirmModal ",
          component: (
            <ConfirmPrompt
              message={"Are you sure you want to remove this Associated Party ?"}
              onCancelClick={this.props.hideDialogueBox}
              onRemoveClick={() => this.deleteParty(partyData)}
              isLogoFooter={true}
              class={"modalBody"}
              removeButtonText={"Confirm"}
              footerClass={"modalFooter"}
              cancelText={"Cancel"}
            />
            
          ),
        });
    }

    deleteParty = (partyData) => {
        const payload = {
            ...partyData,
        }

        this.props.deleteAssociatedParty(payload);
        this.props.hideDialogueBox();
    }

    // render every individual partie cell in parties
    renderParties(parties){
        if (parties && parties.length > 0) {
            let wkpropertyTz = (this.props.workkard.CustomFields && this.props.workkard.CustomFields.some(obj => obj.FieldKey == "policyeffectivedate_timezone")) ? this.props.workkard.CustomFields.filter(item => item.FieldKey == "policyeffectivedate_timezone")[0].Value : "";
            let wkTzValue = wkpropertyTz != "" && this.props.sessionContext.tzData.length > 0 ? this.props.sessionContext.tzData.filter(item => item.DisplayText == wkpropertyTz)[0].UniversalTimeZoneId : this.props.sessionContext.TimeZoneTz;
            let isAuditUser = this.props.sessionContext.IsAuditUser
            const prop = {
                data:parties,
                cellTemplate: PartieCell,
                onScrollHandler: this.onScrollHandler,
                onItemClick: this.onPartyItemClick,
                onCellClick: this.onPartyInfoClick,
                onDeleteClick: this.onDeleteClick,
                type:"div",
                selectedId: '',
                classname:'parties scrollArea',
                extraData: {wkTzValue:wkTzValue, isAuditUser: isAuditUser}
            }

            return (
                <div className="table partiesDesktop">
                    <div className="rowFlex tableHead">
                        <ul>
                            <li className="xsm">&nbsp;</li>
                            <li className="wth-4">{MiddlePanelConstant.Parties.Organization}</li>
                            <li className="wth-4">{MiddlePanelConstant.Parties.ContactName}</li>
                            <li className="wth-4">{MiddlePanelConstant.Parties.MailingAddress}</li>
                            <li className="wth-2">{MiddlePanelConstant.Parties.MailingCity}</li>
                            <li className="wth-2">{MiddlePanelConstant.Parties.PartyType}</li>
                            <li className="xsm">&nbsp;</li>
                        </ul>
                    </div>
                    <div className="rowFlex tableBody">
                        <ListingComponent {...prop}/>
                    </div>
                </div>
            );
        }
        return <div className="noDataFound">{!this.props.isLoading && <EmptyScreen name="Emptyparties" type={this.props.middlePanel.parties.type == "All" ? "activity & workkard" : this.props.middlePanel.parties.type} />}</div>;
    }
    renderPartiesForMobile(parties){
        let isAuditUser = this.props.sessionContext.IsAuditUser;
        if (parties && parties.length > 0) {
            parties = sortArrayByKey(parties,'orgName');
            const prop = {
                data:parties,
                cellTemplate: PartieCell,
                onScrollHandler: this.onScrollHandler,
                onItemClick: this.onPartyItemClick,
                onCellClick: this.onPartyInfoClick,
                onDeleteClick: this.onDeleteClick,
                type:"div",
                selectedId: '',
                className:'associatePartyMobile scrollArea',
                extraData: {isAuditUser: isAuditUser}
            }

            return (                 
                      <ListingComponent {...prop}/>                 
             
            );
        }
        return <div className="noDataFound">{!this.props.isLoading && <EmptyScreen name="Emptyparties" type={this.props.middlePanel.parties.type == "All" ? "activity & workkard" : this.props.middlePanel.parties.type} />}</div>;
    }

    searchParties(value) {
        const {parties} = this.props.middlePanel;
        let trimmedValue = value.trim("");
        this.setState({searchKeyword: trimmedValue});
        const {workkard, activityDetail} = this.props;
        let filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type]

        this.props.resetMiddlePanel({ type: 'parties', value: parties.type })
        const payload = {
            cId: workkard.Id,
            type: parties.type,
            actId: activityDetail.activityId,
            skip: 0,
            take: 15,
            sortBy: 1,
            filterOption: filterOption,
            sort: "OPEN",
            rows: 15,
            key: trimmedValue
        }
        this.props.fetchMiddlePanelPartiesData(payload)
    }


    onAddPartySuccess(type) {
        const activeTab = this.props && this.props.middlePanel && this.props.middlePanel.activeTab;
        const { parties } = this.props.middlePanel;

        if (activeTab == 4 && type.detail && (parties.type == type.detail.entitytype || parties.type == MiddlePanelConstant.All)) {
            let filterOption = parties.type === "All" ? ["activity", "workkard"] : [parties.type]

            const payload = {
                cId: StringConstants.workkard == type.detail.entitytype ? this.props.workkard.Id : 0,
                type: parties.type,
                actId: StringConstants.activity == type.detail.entitytype ? this.props.activityDetail.activityId : 0,
                skip: 0,
                take: 15,
                sortBy: 1,
                filterOption: filterOption,
                sort: "OPEN",
                rows: 15,
            }
            this.props.resetMiddlePanel({ type: 'parties', value: parties.type })
            this.props.fetchMiddlePanelPartiesData(payload);
        }
    }

    onTypeFilterApply(e){
        var filterOption = [], isToast=false;
        const keys = Object.keys(e);
        let type="All";
        let hash="parties"
        {
            e[keys[0]].options
            .filter((optionData) => optionData.checked === true )
            .forEach((filteredValue ) => {
                filterOption = filterOption.concat(filteredValue.value);
            })
        }
        switch(true)
        {
            case (filterOption.includes("workkard") && filterOption.includes("activity")):
                break;
            case (filterOption.includes("workkard")):
                type="workkard";
                hash="cp";
                break;
            case (filterOption.includes("activity")):
                type="activity";
                hash="ap";
                break;
            default:
                isToast=true;
        }

        if(!isToast)
            this.props.hideToast();

        this.SeturlHash(hash);

        const payload = {
            type: 'parties',
            value: type,
            showToast : isToast
        }
        this.props.resetMiddlePanel(payload)
    }

    render(){
        const { parties } = this.props.middlePanel;
        const { isLoading } = this.props;
        const selectOptions = [
            {
                label: MiddlePanelConstant.Parties.ActivityTpyeParties,
                value: MiddlePanelConstant.ActivityType
            },
            {
                label: MiddlePanelConstant.Parties.WorkkardTypeParties,
                value: MiddlePanelConstant.WorkkardType
            }
        ]

        return (
            <div>
                {isLoading &&
                    <LoaderComponent />
                }
                <div className="filterBlock rowFlex">
                    <div className="filterLeft" data-test={`searchParties ${this.state.searchKeyword}`}>
                        <div className="formGroup"><input className="wth-7 partySearch" onChange={(e) => this.searchParties(e.target.value)} type="text" placeholder="Search by Organization, Contact Name, Party Type or Tax ID" /></div>
                    </div>
                    <div data-test={`partiesFilterType ${parties.type}`}>
                        {/* <div className="formGroup">
                            <select className="ml" onChange={(e) => this.onChangeType(e.target.value)}>
                                <option value={MiddlePanelConstant.ActivityType} selected={this.props.history.location.hash.charAt(1) === 'a' ? true: undefined}>{MiddlePanelConstant.Parties.ActivityTpyeParties}</option>
                                <option value={MiddlePanelConstant.WorkkardType} selected={this.props.history.location.hash.charAt(1) === 'c' ? true: undefined}>{MiddlePanelConstant.Parties.WorkkardTypeParties}</option>
                            </select>
                        </div> */}
                        <div className="dropDown medium alignMiddle pd__none ml__1">
                            
                                <label className="mr">Parties</label>
                                <a className="alignMiddle black" href="javascript:void(0)" onClick={() => this.setState({typeFilter : !this.state.typeFilter})}>
                                <span className="dropDownActive">
                                    {parties.type === "All" ? ("Activity & Workkard") : parties.type.charAt(0).toUpperCase()+ parties.type.slice(1) }
                                    <Icons name="downArrow" className="icon ml" />
                                </span>
                                </a>
                            {this.state.typeFilter && <WorkkardMultiOptionFilter filterOptions = {this.state.filterOptions} onCheckChange = {this.onTypeFilterApply} onClose={() => this.setState({typeFilter :false})} showHeader={false} showParentOption={false}  openRight={true}/>}
                        </div>
                    </div>
                </div>
               
                {
                    (
                        parties
                        &&
                        parties.data
                        &&
                        isMobile()?this.renderPartiesForMobile(parties.data):
                        this.renderParties(parties.data)

                    )
                }
            </div>

        );
    }
}


const mapStateToProps = (state) => ({
    activityDetail: state.workkardDetail.activityDetail,
    workkard: state.workkardDetail.workkardDetail,
    middlePanel : state.workkardDetail.middlePanel,
    isLoading: state.workkardDetail.middlePanel.isLoading,
    associatedPartiesData: state.header.associatedParties,
    sessionContext: state.sessionContext,
});

const mapDispatchToProps = (dispatch)=> ({
    fetchMiddlePanelPartiesData: bindActionCreators(fetchMiddlePanelPartiesData, dispatch),
    resetMiddlePanel: bindActionCreators(resetMiddlePanel, dispatch),
    resetMiddlePanelInitialState: bindActionCreators(resetMiddlePanelInitialState, dispatch),
    showDialogueBox: bindActionCreators(showDialogueBox, dispatch),
    showRightPopUpeBox:bindActionCreators(showRightPopUpeBox,dispatch),
    hideRightPopUpBox:bindActionCreators(hideRightPopUpBox,dispatch),
    fetchPartyInfo: bindActionCreators(fetchPartyInfo, dispatch),
    hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
    deleteAssociatedParty: bindActionCreators(deleteAssociatedParty, dispatch),
    hideToast:bindActionCreators(hideToast,dispatch),
});

const ConnectedParties = connect(
    mapStateToProps,
    mapDispatchToProps
)(Parties);

// useLiveRefresh cannot be called from a class component, so the subscription --
// with the burst coalescing and the background-tab gate it carries -- lives here
// and reaches the class as a plain counter prop it can compare.
const PartiesWithLiveRefresh = (props) => {
    const workkardId = useSelector((state) => state.workkardDetail?.workkardDetail?.Id);
    const [refreshToken, setRefreshToken] = React.useState(0);
    useLiveRefresh(PARTY_DOMAINS, () => setRefreshToken((token) => token + 1), { workkardId });
    return <ConnectedParties {...props} refreshToken={refreshToken} />;
};

export default PartiesWithLiveRefresh;